import * as React from 'react';
import Field from '@lendi-ui/field';
import { Size } from '@lendi-ui/radio';
import { InputProp } from '@lendi-ui/text-input';

import { FIELD_VALUES } from '@funnels/constants';
import { EventTracking } from '@funnels/types';

import { FieldLabel } from '../../_common/FieldLabel';
import { FieldWrapper } from '../../_common/style';
import { RadioButtonBlock, RadioButtonInline, StyledRadioGroup } from './index.style';

interface RadioButtonsRadios {
  isDisabled?: boolean;
  label: string;
  value: string;
}

export interface UncontrolledRadioButtonsFieldProps extends EventTracking, Omit<InputProp, 'name' | 'onChange'> {
  direction?: 'row' | 'column';
  label?: string;
  piiStringInLabel?: string;
  labelAfter?: React.ReactNode;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  radios: RadioButtonsRadios[];
  selectedValue?: string | boolean;
  subLabel?: string;
  isDisabled?: boolean;
  isBoxed?: boolean;
  size?: Size;
  isOptional?: boolean;
}

const UncontrolledRadioButtonsField = (props: UncontrolledRadioButtonsFieldProps) => {
  const {
    direction,
    label,
    piiStringInLabel,
    labelAfter,
    onChange,
    radios,
    selectedValue,
    subLabel,
    isDisabled = false,
    isBoxed = true,
    size = 'md',
    isOptional,
  } = props;

  const StyledRadioButton = direction === 'row' ? RadioButtonInline : RadioButtonBlock;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let newValue: string | boolean = e.target.value;

    // Transfer "TRUE" and "FALSE" to boolean true and false
    if (newValue === FIELD_VALUES.TRUE) {
      newValue = true;
    } else if (newValue === FIELD_VALUES.FALSE) {
      newValue = false;
    }

    if (onChange) {
      onChange(e);
    }
  };

  function parseBoolean(value?: string | boolean) {
    // Transfer boolean true and false to "TRUE" and "FALSE"
    if (value === true) {
      value = FIELD_VALUES.TRUE;
    } else if (value === false) {
      value = FIELD_VALUES.FALSE;
    }
    return value;
  }

  return (
    <FieldWrapper>
      <FieldLabel
        label={label}
        labelAfter={labelAfter}
        subLabel={subLabel}
        piiStringInLabel={piiStringInLabel}
        isOptional={isOptional}
      />
      <Field>
        <StyledRadioGroup
          direction={direction}
          legend={''}
          selectedValue={parseBoolean(selectedValue) || ''}
          onChange={handleChange}
          isBoxed={isBoxed}
          isDisabled={isDisabled}
          size={size}
        >
          {radios.map((radio, index) => (
            <StyledRadioButton
              key={index}
              label={radio.label}
              value={radio.value}
              isDisabled={radio.isDisabled}
              aria-label={radio.label}
            />
          ))}
        </StyledRadioGroup>
      </Field>
    </FieldWrapper>
  );
};

export default UncontrolledRadioButtonsField;
